import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQueryWithReAuth } from './base-query'
import type { RentalAutomation, UpsertAutomationBody } from './types/rental'

export const rentalAutomationApi = createApi({
	reducerPath: 'rentalAutomationApi',
	baseQuery: baseQueryWithReAuth,
	tagTypes: ['RentalAutomation'],
	endpoints: (builder) => ({
		getRentalAutomation: builder.query<RentalAutomation | null, string>({
			query: (rentalId) => `/rent/${rentalId}/automation`,
			providesTags: (_r, _e, rentalId) => [{ type: 'RentalAutomation', id: rentalId }],
		}),

		updateRentalAutomation: builder.mutation<
			RentalAutomation | null,
			{ rentalId: string; body: UpsertAutomationBody }
		>({
			query: ({ rentalId, body }) => ({
				url: `/rent/${rentalId}/automation`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: (_r, _e, { rentalId }) => [{ type: 'RentalAutomation', id: rentalId }],
		}),
	}),
})

export const {
	useGetRentalAutomationQuery,
	useUpdateRentalAutomationMutation,
} = rentalAutomationApi
